import { useState } from "react";
import Swal from "sweetalert2";
import invoiceService from "../services/invoiceService";

/**
 * Hook personalizado para manejar la anulación de facturas
 */
export const useInvoiceAnulacion = (onSuccess) => {
  const [showAnularModal, setShowAnularModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [motivoAnulacion, setMotivoAnulacion] = useState("");
  const [isAnulando, setIsAnulando] = useState(false);

  /**
   * Abre el modal de anulación
   */
  const handleOpenAnularModal = (invoice) => {
    setSelectedInvoice(invoice);
    setMotivoAnulacion("");
    setShowAnularModal(true);
  };

  /**
   * Cierra el modal de anulación
   */
  const handleCloseAnularModal = () => {
    setShowAnularModal(false);
    setSelectedInvoice(null);
    setMotivoAnulacion("");
  };

  /**
   * Ejecuta la anulación de la factura
   */
  const handleAnularFactura = async () => {
    if (!selectedInvoice) return;

    if (motivoAnulacion.trim().length < 10) {
      return Swal.fire("Error", "El motivo debe tener al menos 10 caracteres", "warning");
    }

    setIsAnulando(true);

    try {
      await invoiceService.anularFactura(selectedInvoice.id, motivoAnulacion);

      Swal.fire({
        icon: "success",
        title: "¡Factura Anulada!",
        text: "La factura se anuló correctamente",
        confirmButtonText: "Entendido"
      });

      handleCloseAnularModal();
      
      // Llamar callback de éxito
      if (onSuccess) {
        onSuccess();
      }

    } catch (error) {
      console.error("Error al anular factura:", error);
      
      const errorMsg = error.response?.data?.error || "Error al anular la factura";
      const errorType = error.response?.data?.tipo;

      if (errorType === 'CREDITO_FISCAL_VENCIDO') {
        Swal.fire({
          icon: "error",
          title: "No se puede anular",
          html: `
            <p>${errorMsg}</p>
            <br>
            <p><strong>Alternativa:</strong> Emite una Nota de Crédito para reversar esta factura.</p>
          `,
          confirmButtonText: "Entendido"
        });
      } else {
        Swal.fire("Error", errorMsg, "error");
      }
    } finally {
      setIsAnulando(false);
    }
  };

  return {
    // Estado
    showAnularModal,
    selectedInvoice,
    motivoAnulacion,
    isAnulando,
    
    // Setters
    setMotivoAnulacion,
    
    // Funciones
    handleOpenAnularModal,
    handleCloseAnularModal,
    handleAnularFactura
  };
};